import React, { Fragment } from "react";
import { Container } from "reactstrap";
import styled from "styled-components";
import StepProgressBar from "../common/components/StepProgressBar";
import Title from "../job-posting/JobDetailPage/common/Title";
import theme from "../theme";

const { colors, fonts } = theme;

const HeaderWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  text-align: center;

  @media screen and (min-width: 992px) {
    margin-top: unset;
    flex-direction: row;
  }
`;

const StepProgressWrapper = styled.div`
  width: 320px;

  @media screen and (min-width: 400px) {
    width: 345px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (min-width: 992px) {
    align-items: flex-start;
  }
`;

const SubTitle = styled.div`
  height: 24px;
  color: ${colors.secondary};
  font-family: ${fonts.heading};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 5px;
`;

const managementCategoryValues = [
  "Golf School Director",
  "Director of Instruction",
  "Regional/Multi-Facility Manager",
  "Regional Manager",
  "Chief Financial Officer",
  "Chief Executive Officer",
  "General Manager/Head Golf Professional",
  "Assistant General Manager",
  "General Manager",
  "Head Golf Professional",
  "Director of Golf",
];

export const isManagementCategoryJob = (category) =>
  managementCategoryValues.includes(category);
export const requiresCompensationAcknowledgement = (
  status,
  reviewRequestSent,
) => status === "Draft" && !!reviewRequestSent;

export const getCurrentStepItems = (config, currentStep, formState) => {
  const {
    job_category: category,
    review_request_sent: reviewRequestSent,
    status,
  } = formState;
  const skipManagement =
    requiresCompensationAcknowledgement(status, reviewRequestSent) ||
    status === "Complete";

  if (
    currentStep === 2 &&
    isManagementCategoryJob(category) &&
    skipManagement !== true
  ) {
    return config[currentStep - 1];
  } else if (currentStep === 2) {
    return config[currentStep];
  } else {
    return config[currentStep - 1];
  }
};

const stepTitles = ["Details", "Review", "Complete"];

const PostJobView = ({
  config = [],
  currentStep,
  nextStep,
  prevStep,
  editJob,
  theme,
  ...props
}) => {
  const configObj = getCurrentStepItems(config, currentStep, props.formState);
  const { Component } = configObj;
  return (
    <Fragment>
      <HeaderWrapper>
        <Header>
          <Title>
            {editJob && currentStep === 1
              ? `${(props.location.state && props.location.state.header) || "Edit a Job"}`
              : configObj.Title}
          </Title>
          <SubTitle>{configObj.Subtitle}</SubTitle>
        </Header>
        <StepProgressWrapper>
          <StepProgressBar
            currentStep={currentStep}
            activeStep={configObj.activeStep}
            listOfSteps={stepTitles}
          />
        </StepProgressWrapper>
      </HeaderWrapper>
      <Component
        nextStep={nextStep}
        prevStep={prevStep}
        editJob={editJob}
        {...props}
      />
    </Fragment>
  );
};
PostJobView.displayName = "PostJobView";

export default PostJobView;
